import styled from 'styled-components';

import {
  TFeatureCardContainerProps,
  TFeatureCardVariant,
} from '@/shared/components/ui/feature-card/feature-card.types';
import { Paper } from '@/shared/components/ui/paper/paper.styled';
import { rowStyle } from '@/shared/components/ui/shared-styles/shared-styles.styled';

export const FeatureCardContainer = styled(Paper)<TFeatureCardContainerProps>`
  && {
    ${rowStyle};
    padding: 1.25rem;
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 0.75rem;
    height: 100%;

    ${({ onClick }) => !!onClick && `cursor: pointer;`}

    &:after {
      display: none;
    }

    & > .feature-card-icon {
      width: ${({ $variant }) =>
        $variant === TFeatureCardVariant.SMALL ? 1.5 : 2.5}rem;
      height: ${({ $variant }) =>
        $variant === TFeatureCardVariant.SMALL ? 1.5 : 2.5}rem;
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;
